import { render, staticRenderFns } from "./AthleteBackground.vue?vue&type=template&id=0459b66d&"
import script from "./AthleteBackground.vue?vue&type=script&lang=js&"
export * from "./AthleteBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports